import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { ITicketChannelAction } from '../../../../models/ticket';
import { namespace } from 'vuex-class';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { IUserDetails, UserCompactInfo } from '../../../../models/user';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { TicketActionAttachmentTypes } from '../../../../common/enums';
import {
  TICKET_ACTION_DELETE_ATTACHMENT,
  TICKET_ACTION_UPDATE_MESSAGE,
  TICKET_MODULE_NAMESPACE
} from "../../../../store/ticket";
import { error } from "util";

const UserStore = namespace(USER_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE);

@Component({
  components: {
    'message-time-notif-status': async () => import('../ticket-chat-message-time-notif-status/TicketChatMessageTimeNotifStatus.vue')
  }
})
class TicketChatMessageTicket extends Vue {
  /**
   *
   */
  dtActionTypes: { [key: string]: string } | any;
  showMenu: boolean;
  newText: string;
  updateMsgLoading: boolean;
  upMsgOpen: boolean;

  constructor() {
    super();
    this.dtActionTypes = TicketActionAttachmentTypes
    this.showMenu = false
    this.newText = ''
    this.updateMsgLoading = false
    this.upMsgOpen = false
  }
  @UserStore.Getter userInfo: IUserDetails;

  @TicketStore.Action(TICKET_ACTION_UPDATE_MESSAGE)
  storeUpdateMessage: ({ ticketId, channelId, messageId, data }) => Promise<any>;

  @TicketStore.Action(TICKET_ACTION_DELETE_ATTACHMENT)
  storeDeleteAttachment: ({ ticketId, channelId, attachmentId, data }) => Promise<any>;

  @Prop({ required: true, type: [Object] })
  source: ITicketChannelAction;
  @Prop({ required: true, type: Number })
  index: number;

  get coId(): number {
    return this.source.id!;
  }
  get coCreatedBy() {
    return this.source.actor.entity;
  }
  get coIsOwner(): boolean {
    return this.source.actor.fk_actor_entity === this.userInfo.id;
  }

  get coContainerColor(): string {
    return this.coIsOwner ? 'primary' : 'white';
  }
  get coTextColor(): string {
    return this.coIsOwner ? 'white--text' : 'primary--text';
  }
  get coSentAt(): string {
    return DateTimeHelper.parseTimeWithoutUtc(this.source.createdAt);
  }
  labelMsgIsUpdated(data): string {
    if (data.message.edited)
      return ' <i class="grey--text">' + this.$t('TICKET_MESSAGE_UPDATED') + '</i>'
    return ''
  }

  itemsMenu(action): any {
    if (action.action_type === this.dtActionTypes.Message) {
      return [
        { title: 'Modifier', action: this.displayUpdateMessage },
        { title: 'Supprimer', action: this.handleConfirmModal }
      ]
    } else if (action.action_type === this.dtActionTypes.Attachment) {
      return [
        { title: 'Supprimer', action: this.handleConfirmModal }
      ]
    }
    return []
  }

  documentType(link: string): string {
    let itemAttach = link.split('.')
    let long = itemAttach.length
    return itemAttach[long - 1].toUpperCase()
  }
  getFullName(obj: any): string {
    if (obj)
      return new UserCompactInfo(obj).fullName;
    return obj;
  }

  handleClick() {
    this.source["is_loading"] = true;
    this.$emit("resend", { message: this.source, index: this.index })
  }

  displayUpdateMessage(action) {
    console.log('THE ACTION', action)
    action.updating = !action.updating
    this.upMsgOpen = true
    this.newText = action.message.message
  }

  closeUpdate(action) {
    action.updating = false
    this.upMsgOpen = false
  }

  sendUpdateMessage(action) {
    this.updateMsgLoading = true
    let data = {
      message: this.newText,
      action_type: 'message_edit'
    }
    console.log('DATA ===', data)
    console.log('DATA ===', action)
    this.storeUpdateMessage({ ticketId: action.actor.fk_actor_ticket, channelId: action.fk_action_channel, messageId: action.message.id, data })
      .then(response => {
        console.log('RESONSE UPDATE MSG', response)
        this.updateMsgLoading = false
        action.updating = false
        this.upMsgOpen = false
      })
      .catch(error => {
        this.updateMsgLoading = false
        action.updating = false
        this.upMsgOpen = false
      })
  }
  @Emit('open-modal')
  handleConfirmModal(data) {
    console.log('AZERT DATA', data)
    data.open = true
    if (data.action_type === 'attachment') {
      data.text = 'Êtes-vous sûr(e) de vouloir supprimer le fichier'
      data.func = this.sendDeleteAttachment
    } else if (data.action_type === 'message') {
      data.text = 'Êtes-vous sûr(e) de vouloir supprimer le message :</BR>' + data.message.message
      data.func = this.sendDeleteMsg
    }
  }

  async sendDeleteMsg(action) {
    console.log('HEY ', action)
    let data = {
      action_type: 'message_delete'
    }
    return this.storeUpdateMessage({
      ticketId: action.actor.fk_actor_ticket,
      channelId: action.fk_action_channel,
      messageId: action.message.id,
      data
    })
  }

  async sendDeleteAttachment(action) {
    console.log('DELETE ATTACHMENT', action)
    let data = {
      action_type: 'attachment_delete'
    }
    return this.storeDeleteAttachment({
      ticketId: action.actor.fk_actor_ticket,
      channelId: action.fk_action_channel,
      attachmentId: action.attachment.id,
      data
    })
  }
}

export default TicketChatMessageTicket;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-message-item/index.ts